import React from "react"
import styles from "./styles.scss"
import { Link } from "react-router-dom"
import { searchResultsPath } from "utils/paths"

class SmallBox extends React.Component {
  render () {
    const { category } = this.props
    const county = JSON.parse(localStorage.getItem("County"))
    return(
      <Link to={searchResultsPath(county.id, category.id)} className={styles.container}>
        <p>{this.props.text}</p>
        </Link>
    )
  }
}

export default SmallBox


// WEBPACK FOOTER //
// src/pages/LandingPage/components/SmallBox/index.jsx